<template lang="pug">
  v-dialog(v-model='dialog' scrollable persistent max-width='80%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        v-toolbar-title.headline Liquidacion despacho
      v-divider
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-subtitle.title(style='color: black') Detalle de Liquidación
              v-card-text
                v-row(dense)
                  v-col(cols='4' sm='4' md='4')
                    v-select(:readonly='read || form.checkAlmacen' dense outlined :items="asuntos" label="asunto" v-model="form.asunto")
                  v-col(cols='4' sm='4' md='4')
                    v-text-field(dense outlined readonly label="Chofer" v-model='form.idChofer.nombre' )
                  v-col(cols='12' sm='12' md='12')
                    v-textarea(
                      auto-grow,
                      v-if='tipo === "almacen"',
                      :readonly='read',
                      v-model='form.observacionAlmacen',
                      label="Observacion",
                      outlined,
                      dense,
                      v-uppercase)
                    v-textarea(
                    auto-grow,
                    v-else,
                    v-model='form.observacionDespacho',
                    :readonly='read',
                    label="Observacion",
                    outlined,
                    dense,
                    v-uppercase)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense)
                  v-col
                    v-toolbar(flat color='primary' dark)
                      v-toolbar-title Facturas

                    v-expansion-panels(hover multiple)
                      v-expansion-panel(v-for='(item,i) in form.facturas' :key='i' :readonly="!item.tieneDevolucion" )

                        v-expansion-panel-header(disable-icon-rotate :readonly="item.tieneDevolucion === false || read ").facturas

                          v-row(dense)
                            v-col Nro. {{ item.idFactura.numFactura }}
                            v-col(v-if='tipo === "liquidacion" ')
                              v-checkbox.check(:readonly='read' dense v-model="item.llego" @click.native.open="" label="¿Llegó?")

                          template(v-slot:actions)
                            v-checkbox.check(v-show="form.asunto == 'Devolucion Parcial' || form.asunto == 'Devolucion Total'" dense v-model="item.tieneDevolucion" label="Tiene Devolucion" :readonly='read || form.checkAlmacen')

                        v-expansion-panel-content(v-show="item.tieneDevolucion")
                          v-data-table.tabla-facturas(:headers="headers3" :items="item.productos" :items-per-page='-1' hide-default-footer )
                            template(v-slot:item.cantDevuelto='props')
                              v-text-field(:readonly='read || tipo === "liquidacion" || form.asunto === "Devolucion Total" ' dense outlined v-model.number='props.item.cantDevuelto' type="number")
                            template(v-slot:item.idAlmacen='props')
                              v-select(:readonly='read || tipo === "liquidacion" ' dense outlined v-model='props.item.idAlmacen' :items="almacenes" )
                            template(v-slot:item.motivo='props')
                              v-text-field(
                              :readonly='read || tipo === "liquidacion" ',
                              dense,
                              outlined,
                              v-model='props.item.motivo',
                              v-uppercase)
      v-card-actions
        v-spacer
        v-btn(color='red' small dark @click='close')
          v-icon mdi-close
          | Cancelar
        v-btn(v-if='!read' color='teal darken-2' small dark @click='save')
          v-icon mdi-content-save
          | Liquidar
</template>

<script>
import Api from '@/services/methods'
export default {
  name: 'LiquidacionM',
  props: ['dialog', 'editedIndex', 'formPadre', 'read', 'tipo'],
  data: () => ({
    asuntos: [],
    almacenes: [],
    headers2: [
      { text: 'Llego', value: 'estaFaltando' },
      { text: 'Nro Factura', value: 'numFactura' },
      { text: 'Tiene Devolucion', value: 'tieneDevolucion' },
      { text: 'ver', value: 'data-table-expand' }
    ],
    headers3: [
      { text: 'Producto', value: 'idProducto.nombre' },
      { text: 'Producto', value: 'idProducto.descripcion' },
      { text: 'Despachada', value: 'despachada' },
      { text: 'Devuelto', value: 'cantDevuelto' },
      { text: 'Almacen a enviar', value: 'idAlmacen' },
      { text: 'Motivo', value: 'motivo' }
    ],
    form: {
      asunto: '',
      idChofer: {
        nombre: ''
      },
      idVehiculo: '',
      facturas: [],
      observacionDespacho: null,
      observacionAlmacen: null
    },
    defaultForm: {
      asunto: '',
      idChofer: {
        nombre: ''
      },
      idVehiculo: '',
      facturas: [],
      observacionDespacho: null,
      observacionAlmacen: null
    }
  }),

  watch: {
    formPadre (val) {
      if (Object.keys(val).length !== 0) {
        this.form = Object.assign({}, val)
        if (this.tipo === 'almacen') this.asuntos = ['Devolucion Parcial', 'Devolucion Total']
        else this.asuntos = ['No hay Devolucion', 'Devolucion Parcial', 'Devolucion Total']
      }
    },
    'form.asunto' (val) {
      if (this.form.estatus === 'ABIERTO') {
        if (val) {
          if (val === 'No hay Devolucion') {
            // No hay devolucion
            this.limpiarFacturas()
          } else {
            // devoluciones
            let check = null
            if (this.tipo === 'liquidacion') check = this.form.checkAlmacen
            else check = true

            if (check) {
              if (val === 'Devolucion Parcial') {
                // devolucion parcial
                this.limpiarFacturas()
              } else {
                // devolucion total
                this.devolucionTotal()
              }
            } else {
              this.$swal({
                icon: 'error',
                title: 'No puede realizar esta accion',
                text: 'Las devoluciones deben registrarse primero por almacen'
              })
              this.$emit('close')
            }
          }
        }
      }
    }
  },

  created () {
    this.listarAlmacenes()
  },

  methods: {

    limpiarFacturas () {
      if (!this.form.checkAlmacen) {
        this.form.facturas.forEach(factura => {
          factura.tieneDevolucion = false
          factura.productos.forEach(producto => {
            producto.cantDevuelto = 0
          })
        })
      }
    },

    devolucionTotal () {
      this.form.facturas.forEach(factura => {
        factura.tieneDevolucion = true
        factura.productos.forEach(producto => {
          producto.cantDevuelto = producto.despachada
        })
      })
    },

    listarAlmacenes () {
      Api.get('almacen')
        .then(response => {
          response.data.forEach(data => {
            this.almacenes.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    close () {
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultForm)
        this.form.facturas = []
      }, 300)
      this.$emit('close')
    },

    validarCampos () {
      if (!this.form.asunto) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }

      if (this.tipo === 'almacen' && (!this.form.observacionAlmacen || !this.form.observacionAlmacen === '')) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }

      if (this.tipo === 'despacho' && (!this.form.observacionDespacho || !this.form.observacionDespacho === '')) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }

      if (this.form.asunto === 'Devolucion Parcial') {
        let boolFacturas = false
        for (let factura of this.form.facturas) {
          if (factura.tieneDevolucion) {
            boolFacturas = true
            let boolproductos = false
            for (let producto of factura.productos) {
              if (producto.cantDevuelto > 0) {
                boolproductos = true
                break
              }
            }
            if (!boolproductos) {
              this.$swal({
                icon: 'error',
                title: 'Devoluciones incompletas',
                text: 'Debe seleccionar al menos una factura y al menos un producto de esa factura para continuar'
              })
              return true
            }
          }
        }
        if (!boolFacturas) {
          this.$swal({
            icon: 'error',
            title: 'Devoluciones incompletas',
            text: 'Debe seleccionar al menos una factura'
          })
          return true
        }
      }

      for (let factura of this.form.facturas) {
        for (let producto of factura.productos) {
          if (producto.cantDevuelto > producto.despachada) {
            this.$swal({
              icon: 'error',
              title: 'Error en las cantidades',
              text: 'Las cantidades devueltas no pueden ser mayor a las despachada. Por favor verifique lo datos'
            })
            return true
          }

          if (this.tipo === 'almacen' && producto.cantDevuelto > 0) {
            if (!producto.idAlmacen) {
              this.$swal({
                icon: 'error',
                title: 'Error en los almacen',
                text: 'Debe seleccionar un almacen al cual enviar los productos'
              })
              return true
            }

            if (!producto.motivo && producto.motivo.trim() === '') {
              this.$swal({
                icon: 'error',
                title: 'Error en los motivos',
                text: 'Debe especificar un motivo de la devolución'
              })
              return true
            }
          }
        }
      }
      return false
    },

    save () {
      if (!this.validarCampos()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => { this.$swal.showLoading() }
        })
        if (this.tipo === 'almacen') this.form.checkAlmacen = true
        this.form.tipo = this.tipo
        Api.put('liquidacionDespacho', this.form)
          .then(response => {
            this.close()
            this.$swal({
              icon: 'success',
              title: 'Inclusion exitosa',
              text: 'Todos los cambios han guardados'
            })
            this.$emit('save')
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',   
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message);
            }
          })
      }
    }
  }
}
</script>
